import React, {useState} from 'react';
import TitleWithIcon from './TitleWithIcon'
import VisDiv from './frontend_components/VisDiv';
import { AiFillPlusCircle } from 'react-icons/ai';
import {useStateContext} from '../context/StateContext';
import ModalContent from './ModalContent';
import NewDeviceField from './NewDeviceField';
import TextField from './TextField';
import { v4 as uuidv4, v4 } from 'uuid';
import RegisterIcon from './RegisterIcon';
import { useCreateReplace } from '../hooks/mutations';
import useNetworkStatus from '../hooks/useNetworkStatus';
import useNetwork from '../hooks/useNetwork';
import { successAlert,errorAlert, keyId  } from '../lib/utils';
import { useQueryClient } from '@tanstack/react-query';
import { clientUser, facilityClient } from '../lib/userPermissions';
import { set } from 'lodash';
import TrueFalseToggle from './TrueFalseToggle';



const SliderRegistri = ({registers, showArchived, templates, setLoading, hideTemplates, closeAllInfo=()=>{}}) => {

    const {
        site,
        register,
        client,
        setRegister,
        setCurrentTemplate,
        setRegisters,
        sUser,
        LDB

    } = useStateContext();

    const queryClient = useQueryClient()

    const networkStatus = useNetworkStatus()

    const [disableContinue, setDisableContinue] = useState(false)

    const [selectedTemplate, setSelectedTemplate ] = useState(undefined)
    const testing = false



    const testFunction = () => {
        console.log(orderedRegisters)
        //console.log("tamplates", templates)
    }
    

    const AddName = ({template, site}) => {
        const [nameValue, setNameValue] = useState("")
        const [checkResetDays, setCheckResetDays] = useState(120)
        const [notInMaintenance, setNotInMaintenance] = useState(false)
        const continueDisabledColor = disableContinue && "grey"
        const doc = {
            label: template?.family, 
            devices:[],
            _key: keyId(),
            _id: uuidv4(),
            _type:"register",
            notInMaintenance: notInMaintenance,
            checkResetDays: Number(checkResetDays),
            postedBy: [{ _type: 'postedBy', _ref: sUser._id,  _key: keyId()}],
            site: {
                _ref:site?._id,
                _type:"reference",
                _key: keyId(),
            },
            template: {
                _ref:template?._id,
                _type:"reference",
                _key: keyId(),
            },
            registerName: nameValue,
            status: "ATTIVO"
        }
        const {mutate: insertRegister} = useCreateReplace({
       
                onMutate: async (newDoc) => {

                    await queryClient.cancelQueries({ queryKey: ['registers', site] })
                    const previousRegisters = queryClient.getQueryData(['registers', site])
            
                    const doc = newDoc?.doc
                    
                    queryClient.setQueryData(['registers', site], (old) =>{ 
                        const registerTemplate = !Array.isArray(templates) ? undefined : templates?.find?.(x=>x?._id == newDoc?.template?._ref) 
                        const oldData = old?.length > 0 ? (!Array.isArray(old) ? [] : old) : []
                        const newData = [...oldData?.filter?.(x=>x?._id!== doc?._id), doc]
                        selectRegister(doc)
                        setRegisters(newData)
                        //setRegister(doc)
                        //setCurrentTemplate(registerTemplate)
                        //setSelectedTemplate(registerTemplate)
                        
                        return newData
                    })
                    return { previousRegisters, register}
                },
                onError: (err, newDoc, context) => {
                    errorAlert("CREAZIONE PRESIDIO NON RIUSCITO, RIPROVA")
                    queryClient.setQueryData(['registers', site], context?.previousRegisters)
                    setRegisters(context.previousRegisters)
                    setRegister(undefined)
                    closeAllInfo()
                    setCurrentTemplate(undefined)
                    
                    console.error('Oh no, the update failed: ', err?.message)
                    
                }
    
    })

        const onContinue = () => {
         insertRegister({doc})
        }
        
        return (
        
        <div className={"selector"}>
            {`${LDB("index", "addNewRegister")} ${template?.family} IN ${site?.label}`}
                <NewDeviceField label={LDB("index","addRegisterName")}> 
                    <TextField
                    //onSelect={()=>setDisableContinue(true)} 
                    onChange={(e) => setNameValue(e.target.value)}
                    //onBlur={()=>{
                        //setDisableContinue(false)
                    // }} 
                    />
                    <TextField 
                        value={checkResetDays} 
                        label={"GIORNI DI CHECK RESET"}
                        type='number'
                        onChange={(e) => setCheckResetDays(e.target.value)} 
                        //description={"Inserire un email per creare un nuovo utente o per duplicare uno esistente."} 
                        descriptionDivider={false}
                    />
                    <TrueFalseToggle 
                        value={notInMaintenance}
                        onClick={()=>setNotInMaintenance(!notInMaintenance)}
                        label={"NON IN MANUTENZIONE"}
                    />
                </NewDeviceField> 
                <div style={{display:"flex", justifyContent:"center"}}>
                    <div className="new-register">
                        <div className="footer">
                            <button
                                onClick={() => {
                                setSelectedTemplate("");
                                }}
                                id="cancelBtn"
                            >
                                {LDB("misc","cancel")}
                            </button>
                            <button style={{backgroundColor: continueDisabledColor}} disabled={disableContinue} onClick={onContinue}>{LDB("misc","save")}</button>
                        </div>
                    </div>
                </div> 
        </div>
   ) }


    const addRegister = (template, currentSite) => {
        //console.log("add register:",template);
        //console.log("registers", registers);
        //console.log("tamplates", templates);        
        //console.log("current site", currentSite);
        setSelectedTemplate(template)
        //setCurrentTemplate(template)
    }

        

    const setCurrentRegister = (registerIcon, template) => {
        setLoading(true)
        //console.log("set register:",registerIcon)
        //console.log("current register", register)
        setCurrentTemplate(template)
        setRegister(registerIcon)
        closeAllInfo()
        //window.location.reload(false);
        setLoading(false)
    }


    
    const isActive = (registerIcon) => {
        if(registerIcon?._id == register?._id) return true
        return false
    }

    const registerTemplateData = (registerIcon) => !Array.isArray(templates) ? undefined : templates?.find?.((x)=>x._id==registerIcon?.template?._ref)

    const selectRegister = (register, currentRegister) => {
        if(register?._id == currentRegister?._id){
            //console.log("CLICKED SAME REGISTER")
            setRegister(undefined)
            closeAllInfo()
        }
        else {
            setCurrentRegister(register, registerTemplateData(register));
            //console.log("selected register", register)
        }

    }
    function compare( a, b ) {
        if ( a?.order < b?.order ){
          return -1;
        }
        if ( a?.order > b?.order ){
          return 1;
        }
        return 0;
      }
    const registersArray = registers?.length > 0 ? registers : []  
    const orderedRegisters = !Array.isArray(registersArray) ? [] : registersArray?.map?.((item)=>{
        const template = !Array.isArray(templates) ? undefined : templates?.find?.(x=>x?._id==item?.template?._ref) 
        //console.log(template?.order)
        return ({...item, order:template?.order })
        }) 

    const iconOpacity = (item) => {
        if(item?.status == "ARCHIVIATO") return 0.5
        if(item?.notInMaintenance) return 0.3
        return 1

    }
    const iconOverlay = (item) => {
        //if(item?.notInMaintenance) return 0.7
        return {}
    }

  return (
    <>
    <div className='horizontal-swipe-wrapper' style={{marginTop:"10px"}}>
        
        {registers && (!Array.isArray(registers) ? [] : orderedRegisters.sort(compare).filter?.(x=>{
        if(showArchived) return x
        return x?.status !== "ARCHIVIATO"
        })
        ?.map?.((item)=>(
            <div key={item._id} className='horizontal-swipe-box' style={{backgroundColor:"", opacity: iconOpacity(item)}}> 
                <RegisterIcon archived = {item?.status == "ARCHIVIATO"} currentRegister={register} template={registerTemplateData(item)} templates={templates} register={item} additionalTitle={item?.registerName} onClick={()=>selectRegister(item, register)}/> 
            </div>
        )))}
        <VisDiv rules={[registers?.length>0, networkStatus, clientUser(sUser), facilityClient(client, sUser), !hideTemplates]} style={{borderRight: "1px solid grey", height:"50px", marginRight:"18px"}}></VisDiv>

            {templates?.length > 0 && (!Array.isArray(templates) ? [] : templates.sort(compare).map?.((item)=>(
                <VisDiv rules={[networkStatus, !hideTemplates, clientUser(sUser), facilityClient(client, sUser) ]} key={item._id} className='horizontal-swipe-box' style={{backgroundColor:"",}}> 
                    <RegisterIcon template={item} additionalTitle={LDB("misc", "template")} templates={templates} onClick={()=>addRegister(item, site)}/> 
                </VisDiv>
          )))}
     
    </div>
    <VisDiv rules={[testing]}><button onClick={testFunction}>test</button></VisDiv>
    <VisDiv rules={[selectedTemplate]}>
        <AddName template={selectedTemplate} site={site}/>
    </VisDiv>
    
    </>
  )
}

export default SliderRegistri
